import React from "react";
import moment from "moment-timezone";

import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { IntlFormatUSD } from "../../../../../utils";
import { CENTS_IN_DOLLAR, HOURS_12_FORMAT_WITH_DATE } from "../../../../../constants";
import { IGetPassedSubscriptionPurchaseDateResponse } from "../../../../../api/billing/index.types";
import { CopyToClipboard } from "../../../../../components/ui";

export const REBILL_STATUS_COLORS = {
  required: {
    color: "#ffe5a0",
    name: "Required to have rebill",
  },
  missed: {
    color: "#fec5bb",
    name: "Didn't rebill",
  },
};

const styles: React.CSSProperties = {
  display: "block",
  borderRadius: "13px",
  textAlign: "center",
};

export const getColumns = (reportTitleDate: string): Array<IColum> => [
  {
    by: "accounts_id",
    title: "Account ID",
    path: "accounts_id",
    isSortable: true,
    //@ts-ignore
    getCellValue: (
      accounts_id: string,
      rest: IGetPassedSubscriptionPurchaseDateResponse["data"]["passedSubscriptionPurchaseDate"][number]
    ): React.ReactElement => {
      let isRebillRequired = false;
      let isExpiredRebill = false;

      const { rebilsAfterPurchase } = rest;
      const isHaveRebills = rebilsAfterPurchase.length > 0;

      const purchaseDate = moment(rest.purchase_date).tz("America/Chicago");
      if (isHaveRebills) {
        const daysAfterPurchase = moment(moment(rebilsAfterPurchase[0].purchase_date))
          .tz("America/Chicago")
          .diff(purchaseDate, "days");

        if (daysAfterPurchase >= 29) {
          isRebillRequired = true;
        }
      }

      if (!isHaveRebills) {
        const daysAfterPurchase = moment(moment(rest.report_title_date || reportTitleDate))
          .tz("America/Chicago")
          .diff(purchaseDate, "days");

        if (daysAfterPurchase >= 30) {
          isExpiredRebill = true;
        }
      }

      return (
        <span
          style={{
            ...styles,
            ...(isRebillRequired && {
              backgroundColor: REBILL_STATUS_COLORS.required.color,
            }),
            ...(isExpiredRebill && {
              backgroundColor: REBILL_STATUS_COLORS.missed.color,
            }),
          }}
        >
          {accounts_id}
        </span>
      );
    },
  },
  {
    by: "account.name",
    title: "Name",
    path: "account.name",
    isSortable: true,
  },
  {
    by: "account.email",
    title: "Email",
    path: "account.email",
    isSortable: true,
    //@ts-ignore
    getCellValue: (account_email: string): React.ReactElement => {
      return <CopyToClipboard value={account_email} />;
    },
  },
  {
    by: "purchase_date",
    title: "Purchase Date",
    path: "purchase_date",
    isSortable: true,
    //@ts-ignore
    getCellValue: (purchase_date: string): React.ReactElement => {
      return (
        <span>
          {moment(purchase_date as string)
            .tz("America/Chicago")
            .format(HOURS_12_FORMAT_WITH_DATE)}
        </span>
      );
    },
    copyToClipBoardCallBack: (purchase_date: string): string => {
      return moment(purchase_date as string)
        .tz("America/Chicago")
        .format(HOURS_12_FORMAT_WITH_DATE);
    },
  },
  {
    by: "price_usd",
    title: "Price",
    path: "price_usd",
    isSortable: true,
    //@ts-ignore
    getCellValue: (price_usd: number): React.ReactElement => {
      return <span>{IntlFormatUSD(price_usd / CENTS_IN_DOLLAR)}</span>;
    },
    //@ts-ignore
    copyToClipBoardCallBack: (price_usd: number): string => {
      return IntlFormatUSD(price_usd / CENTS_IN_DOLLAR);
    },
  },
  {
    by: "plan.name",
    title: "Plan",
    path: "plan.name",
    isSortable: true,
  },
];
